import { render, staticRenderFns } from "./ClassDetailModal.vue?vue&type=template&id=3d7030dc&scoped=true"
import script from "./ClassDetailModal.vue?vue&type=script&lang=js"
export * from "./ClassDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ClassDetailModal.vue?vue&type=style&index=0&id=3d7030dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7030dc",
  null
  
)

export default component.exports